import { makeStyles } from '@mui/styles';
const actionButtonStyles = makeStyles(({ palette }) => ({
    button: {},
    loader: {
        color: palette.primary.contrastText,
        marginRight: 10,
    },
}), { name: 'Login_ActionButton' });
export default actionButtonStyles;
//# sourceMappingURL=actionButton.styles.js.map